/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowaskplace3Inputs */

const en_aiflowaskplace3 = /** @type {(inputs: Aiflowaskplace3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where does the event take place?`)
};

const de_aiflowaskplace3 = /** @type {(inputs: Aiflowaskplace3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo findet das Event statt?`)
};

/**
* | output |
* | --- |
* | "Where does the event take place?" |
*
* @param {Aiflowaskplace3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaskplace3 = /** @type {((inputs?: Aiflowaskplace3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaskplace3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaskplace3(inputs)
	return de_aiflowaskplace3(inputs)
});
export { aiflowaskplace3 as "aiFlowAskPlace" }